'use client'

import React from 'react'
import { Clock, AlertTriangle } from 'lucide-react'
import { calculateOfferDuration } from '@/constants/hooks'

interface Props {
    endDate?: string | null
}

const ExpiryTag = ({ endDate }: Props) => {
    const label = calculateOfferDuration(endDate ?? null)

    if (label === 'Offer expired') {
        return (
            <span className="inline-flex items-center gap-1 text-[9px] font-bold px-2 py-0.5 rounded-md bg-rose-50 text-rose-600 border border-rose-200">
                <AlertTriangle size={8} />
                Expired
            </span>
        )
    }

    if (label === 'Life Time' || !label || label === 'Invalid date') {
        return null
    }

    if (label === 'Last day') {
        return (
            <span className="inline-flex items-center gap-1 text-[9px] font-bold px-2 py-0.5 rounded-md bg-amber-50 text-amber-800 border border-amber-200">
                <Clock size={8} />
                Last Day!
            </span>
        )
    }

    // e.g. "3 days left" — check if urgent (≤ 3 days)
    const daysMatch = label.match(/^(\d+)\s+day/)
    const days = daysMatch ? parseInt(daysMatch[1]) : null
    const isUrgent = days !== null && days <= 3

    return (
        <span className={`inline-flex items-center gap-1 text-[9px] font-bold px-2 py-0.5 rounded-md border ${
            isUrgent
                ? 'bg-amber-50 text-amber-800 border-amber-200'
                : 'bg-slate-50 text-slate-600 border-slate-200'
        }`}>
            <Clock size={8} />
            {label}
        </span>
    )
}

export default ExpiryTag
